var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXGradientGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 32,
    stroke: "url(#paint0_linear_1159_190)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9709 21H46.2487L36.903 31.6815L47.8974 46.2167H39.2888L32.5463 37.4012L24.8313 46.2167H20.5509L30.547 34.7916L20 21H28.8271L34.9218 29.0577L41.9709 21ZM40.4695 43.6562H42.8399L27.5391 23.426H24.9955L40.4695 43.6562Z",
    fill: "url(#paint1_linear_1159_190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_190",
    x1: 2,
    y1: 66,
    x2: 66,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_190",
    x1: 20,
    y1: 46.2167,
    x2: 47.8974,
    y2: 46.2167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGradientGradient);
export default __webpack_public_path__ + "static/media/XGradientGradient.4c21864fc7f75aeaf6698b643a230604.svg";
export { ForwardRef as ReactComponent };